module.exports = __webpack_public_path__ + "img/infoImg4.9d3e02b2.png";